export enum Belegart {
    Gutschrift = 'GUTSCHRIFT',
    Rechnung = 'RECHNUNG',
    Lieferschein = 'LIEFERSCHEIN',
    Angebot = 'ANGEBOT',
}


